export default function SchemaDivider({ label }: { label: string }) {
  return (
    <div className="ml-4">
      <div className="py-1 border-t border-[sec-blue-gray-100]">
        <div className="f-row-y-center text-input-label !text-sec-blue-gray-300">{label}</div>
      </div>
    </div>
  );
}
